import i from "./index592.js";
import { isEmpty as u } from "./index565.js";
import { isArray as c, isDate as a } from "./index575.js";
const W = (r, t) => [
  r > 0 ? r - 1 : void 0,
  r,
  r < t ? r + 1 : void 0
], d = (r) => Array.from(Array.from({ length: r }).keys()), D = (r) => r.replace(/\W?m{1,2}|\W?ZZ/g, "").replace(/\W?h{1,2}|\W?s{1,3}|\W?a/gi, "").trim(), g = (r) => r.replace(/\W?D{1,2}|\W?Do|\W?d{1,4}|\W?M{1,4}|\W?Y{2,4}/g, "").trim(), l = function(r, t) {
  const e = a(r), n = a(t);
  return e && n ? r.getTime() === t.getTime() : !e && !n ? r === t : !1;
}, y = function(r, t) {
  const e = c(r), n = c(t);
  return e && n ? r.length !== t.length ? !1 : r.every((s, o) => l(s, t[o])) : !e && !n ? l(r, t) : !1;
}, A = function(r, t, e) {
  const n = u(t) || t === "x" ? i(r).locale(e) : i(r, t).locale(e);
  return n.isValid() ? n : void 0;
}, x = function(r, t, e) {
  return u(t) ? r : t === "x" ? +r : i(r).locale(e).format(t);
}, T = (r, t) => {
  var e;
  const n = [], s = t?.();
  for (let o = 0; o < r; o++)
    n.push((e = s?.includes(o)) != null ? e : !1);
  return n;
}, h = (r) => c(r) ? r.map((t) => t.toDate()) : r.toDate();
export {
  W as buildTimeList,
  l as dateEquals,
  h as dayOrDaysToDate,
  D as extractDateFormat,
  g as extractTimeFormat,
  x as formatter,
  T as makeList,
  A as parseDate,
  d as rangeArr,
  y as valueEquals
};
